import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { Hero } from '../../components/Hero';
import { FiltersTabsContainer } from '../FiltersTabsContainer';
import { FiltersContainer } from '../FiltersContainer';
import { useSearchStringRedesignEnabled } from '../../hooks/useSearchStringRedesignEnabled';
import { SearchStringBlockContainer } from '../SearchStringBlockContainer/SearchStringBlockContainer';
import { selectSeoData } from '../../selectors/seoData';

export const HeroContainer: React.FC = () => {
  const seoData = useSelector(selectSeoData);
  const isChildrenDayEnabled = useSelector((state: IApplicationState) => state.features.isChildrenDayEnabled);

  const isRedesignEnabled = useSearchStringRedesignEnabled();

  const filtersBlock = isRedesignEnabled.isEnabled ? (
    <SearchStringBlockContainer />
  ) : (
    <>
      <FiltersTabsContainer />
      <FiltersContainer />
    </>
  );

  return (
    <Hero
      title={seoData?.mainTitle || ''}
      isDobroshriftEnabled={false}
      isChildrenDayEnabled={isChildrenDayEnabled}
      filtersBlock={filtersBlock}
      isRedesignEnabled={isRedesignEnabled.isEnabled}
      searchStringExperimentGroup={isRedesignEnabled.experimentGroup}
    />
  );
};
